import {
    SET_ACCESS_TOKEN,
    SET_ACCESS_TOKEN_PROMISE
} from "@/store/mutation-types";

export const mutations = {
    [SET_ACCESS_TOKEN] (state, newToken) {
        state.accessToken = newToken;
        state.accessTokenPromise = undefined;
    },
    [SET_ACCESS_TOKEN_PROMISE] (state, newPromise) {
        state.accessTokenPromise = newPromise;
    }
};

export type Mutations = typeof mutations;
